import script from "./Chip.vue?vue&type=script&setup=true&lang=js"
export * from "./Chip.vue?vue&type=script&setup=true&lang=js"

import "./Chip.vue?vue&type=style&index=0&id=f8b3957e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8b3957e"]])

export default __exports__